export default __webpack_public_path__ + "static/media/school_coloured3.4078853e.png";